// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import { getSelectedPageProductRange } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.util';
import { getViewportInfo, isClient } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import {
  StyledBodyCopy,
  ItemsCountContent,
  ItemsCountContentNumber,
  ShowLabelStyled,
} from '../LoadedProductsCount.style';

class LoadedProductsCount extends React.PureComponent {
  slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);

  render() {
    const showingXItemsLabel = renderLabel(
      this.slpLabels.lbl_showing_x_items,
      'lbl_showing_x_items'
    );

    const ItemLabel = renderLabel(this.slpLabels.lbl_item, 'lbl_item');

    const ItemsLabel = renderLabel(this.slpLabels.lbl_items, 'lbl_items');

    const rangeOfLabel = renderLabel(this.slpLabels.lbl_range_of, 'lbl_range_of');
    const {
      className,
      totalProductsCount,
      isFavoriteView,
      selectedPageProductCount,
      productLimitPerPage,
      selectedPage,
      isPaginationViewEnabled,
      isSLP,
    } = this.props;
    const { from, till } = getSelectedPageProductRange(
      productLimitPerPage,
      selectedPage,
      selectedPageProductCount
    );
    const showingXItems = !isFavoriteView ? showingXItemsLabel : '';
    const isMobile = isClient() && getViewportInfo().isMobile;
    return (
      <StyledBodyCopy
        className={`${className} count-section`}
        component="div"
        fontSize="fs14"
        fontFamily="secondary"
        fontWeight="semibold"
        isSLP={isSLP}
      >
        {totalProductsCount > 0 && (
          <ItemsCountContent className="items-count-content" aria-live="polite" aria-atomic="true">
            <ShowLabelStyled className="show-label">{showingXItems}</ShowLabelStyled>
            {isPaginationViewEnabled && !isMobile && (
              <>
                <ItemsCountContentNumber className="items-count-content-number current-page-product-range">{`${from}-${till}`}</ItemsCountContentNumber>
                <ShowLabelStyled className="show-label">{rangeOfLabel}</ShowLabelStyled>
              </>
            )}

            <ItemsCountContentNumber className="items-count-content-number">
              {totalProductsCount > 0 ? totalProductsCount : 0}
            </ItemsCountContentNumber>
            <span className="itemsLabel">{totalProductsCount > 1 ? ItemsLabel : ItemLabel}</span>
          </ItemsCountContent>
        )}
      </StyledBodyCopy>
    );
  }
}

LoadedProductsCount.propTypes = {
  className: PropTypes.string,
  totalProductsCount: PropTypes.number,
  isFavoriteView: PropTypes.bool,
  selectedPageProductCount: PropTypes.number,
  selectedPage: PropTypes.number,
  productLimitPerPage: PropTypes.number,
  isPaginationViewEnabled: PropTypes.bool,
  isSLP: PropTypes.bool,
};

LoadedProductsCount.defaultProps = {
  className: '',
  totalProductsCount: 0,
  isFavoriteView: false,
  selectedPage: 1,
  productLimitPerPage: 0,
  selectedPageProductCount: 0,
  isPaginationViewEnabled: false,
  isSLP: false,
};

export default errorBoundary(LoadedProductsCount);
export { LoadedProductsCount as LoadedProductsCountVanilla };
